// startup
// Load entry module
__webpack_require__("./src/scripts/index.js");
__webpack_require__("./src/scss/styles.scss");
// This entry module used 'exports' so it can't be inlined
